const safeFailureLabels: Record<string, string> = {
  PAYMENT_TIMEOUT_UNPAID: "支付超时未完成",
  APPLE_VERIFY_TIMEOUT: "支付凭证校验超时",
  APPLE_VERIFY_FAILED: "支付凭证校验失败",
  APPLE_RECEIPT_MISSING: "支付凭证缺失",
  APPLE_PRODUCT_MISMATCH: "支付商品不匹配",
  APPLE_TRANSACTION_DUPLICATE: "支付交易已处理",
  FULFILLMENT_FAILED: "权益发放失败，请联系客服",
  PINGXX_CONFIG_MISSING: "支付服务暂不可用",
  PINGXX_CREATE_FAILED: "支付单创建失败",
  PINGXX_REQUEST_TIMEOUT: "支付请求超时",
  PINGXX_WEBHOOK_TIMEOUT: "支付结果确认超时",
  UNKNOWN_PAYMENT_FAILURE: "支付或履约失败，请查服务端审计",
};

export function safeOrderFailureText(failureCode: string | null) {
  if (!failureCode) return "";
  return safeFailureLabels[failureCode] || "支付或履约失败，请查服务端审计";
}

export function buildOrderFilters(input: {
  userId: string;
  status: string;
  userType: string;
  productType: string;
  fulfillmentStatus: string;
}) {
  const params: Record<string, string> = {};
  if (input.userId.trim()) params.user_id = input.userId.trim();
  if (input.status) params.status = input.status;
  if (input.userType) params.user_type = input.userType;
  if (input.productType) params.product_type = input.productType;
  if (input.fulfillmentStatus) params.fulfillment_status = input.fulfillmentStatus;
  return params;
}
